import { AppNotificationViewDto } from '../../data-transfer-objects';

/**
 * Event Types
 */
export enum AppNotificationEventTypes {
  NOTIFICATION_UPSERTED = '[App Notification] Notification Upserted',
  NOTIFICATION_DELETED = '[App Notification] Notification Deleted',
}

/**
 * Payloads
 */
export interface AppNotificationUpsertedEventPayload {
  appNotificationView: AppNotificationViewDto;
}

export interface AppNotificationDeletedEventPayload {
  appNotificationIds: number[];
}

/**
 * Events
 */
export class AppNotificationUpsertedEvent {
  readonly type = AppNotificationEventTypes.NOTIFICATION_UPSERTED;

  constructor(public payload: AppNotificationUpsertedEventPayload) {}
}

export class AppNotificationDeletedEvent {
  readonly type = AppNotificationEventTypes.NOTIFICATION_DELETED;

  constructor(public payload: AppNotificationDeletedEventPayload) {}
}
